// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"88217a61","453":"af7143f6","546":"cb42c8c7","769":"afc6e783"}[chunkId] + ".chunk.js";
};